(function(){
    'use strict';
    
    /*
        JS Usage must follow:
        jcu_js_v1.fn.functionName = function(){
           //do things here 
        }
        jcu_js_v1.vars.variableName = "I am a variable";

    */
    
}());
